import BaseResource from './BaseResource';
import ContributionResource from './ContributionResource';

export default class DocumentResource extends BaseResource {
  constructor() {
    super({ url: '/api/contributions' });
  }

  contribution(id) {
    return new ContributionResource(`${this.url}/${id}`);
  }
}
